module.exports.default = {
    "ORDER": "Pedido",
    "SCHEDULE.YOU_ARE_ALL_SET": "Tudo pronto!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Seu pedido foi agendado para",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Olá #, por favor agende sua entrega",
    "SCHEDULE.SCHEDULE_NOW": "Agenda agora",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Entrega & Atualização de status",
    "SCHEDULE.EMAIL_UPDATES": "Atualiação por email",
    "SCHEDULE.SMS_UPDATES": "Atualização por SMS",
    "SCHEDULE.DISABLE_UPDATES": "Eu não quero receber atualizações",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Eu gostaria de receber atualização de status nos canais:",
    "OOPS": "Opss!",
    "SOMETHING_WENT_WRONG": "Algo deu errado",
    "REFRESH": "Atualizar",
    "PAGE_NOT_FOUND": "Página não econtrada",
    "COULD_NOT_FIND_PAGE": "Não conseguimos achar a página que está procurando.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Não pode enviar menssagem vazia",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Por favor, digite sua mensagem ao entregador.",
    "TRACKING.SEND": "Enviar",
    "TRACKING.ARRIVING_AT": "Chegando em",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Mapa",
    "TRACKING.SATELLITE": "Satelite",
    "TRACKING.TERRAIN": "Terreno",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Olá, cheguei!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "seu entregador, chegou as ",
    "COMPLETED": "Você não tem entregas no momento",
    "RATING.SKIP": "Agora não",
    "RATING.WHAT_WENT_WELL": "O que foi mais gostou ?",
    "RATING.WHAT_WENT_WRONG": "O que podemos melhorar ?",
    "RATING.THANK_YOU": "Obrigado",
    "RATING.FOR_USING_OUR_SERVICE": "Obrigado por usar os nossos serviços!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Como foi sua experiência com a entrega?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Por favor, ajude-nos a melhorar ao classificar a sua experiência",
    "SCHEDULE.RATE_US": "Avalie agora!",
    "TERM_OF_USE": "Termos dos serviço",
    "PRIVACY_POLICY": "Política de Privacidade",
    "SHARING_MY_LOCATION": "Minha localização",
    "SHARING_LOADING": "Carregando",
    "REQUIRED_FIELD_MESSAGE": "Campo obrigatório.",
    "CONTACT_NAME": "Nome de contato",
    "PHONE_NUMBER": "Telefone",
    "EMAIL_ADDRESS": "Email",
    "SEND": "Enviar",
    "FORWARD.THIS_ORDER": "Encaminhar pedido",
    "FORWARD.TO_CONTACT": "Encaminhar contato",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Tem certeza de que deseja encaminhar este pedido?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "foi enviado pedido para você",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Tem certeza que deseja cancelar este pedido ?",
    "ACCEPT": "Aceitar",
    "REJECT": "Rejeitar",
    "PICKUP.SET_PICKUP_TIME": "Estou à caminho",
    "PICKUP.IVE_ARRIVED": "Cheguei",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Oops, Algo deu errado",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Por favor, tente novamente",
    "PICKUP.MIN": "Min:",
    "PICKUP.SHOW_THIS_NUMBER": "Mostre este número para pegar seu pedido",
    "PICKUP.IM_OUTSIDE": "Cheguei",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Nos informe quando chegar aqui.",
    "PICKUP.I_WILL_ARRIVE_AT": "Eu chegarei",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Horário de chegada confirmado",
    "PICKUP.IN": "De",
    "PICKUP.TO": "Para",
    "PICKUP.COLLECT": "Pedido coletado",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Selecione o tipo de transporte",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Confirme o tipo de transporte",
    "PICKUP.CANCEL": "Cancelar",
    "PICKUP.CONFIRM_TIME": "Confirmar o horário de retirada",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "O(a) entregador(a) está atualmente a 1 parada até chegar em você",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "paradas até chegar em você",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "O(a) entregador(a) está atualmente a",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Próximo",
    "PICKUP.SKIP": "Pular",
    "CAR_ARRIVED.TITLE": "Bom saber que chegou! Ajude nos te achar:",
    "CAR_ARRIVED.PARKING_SPOT": "Local & número vaga",
    "CAR_ARRIVED.LICENSE_PLATE": "Placa do veículo",
    "CAR_ARRIVED.VEHICLE_MODEL": "Marca & Modelo",
    "CAR_ARRIVED.VEHICLE_COLOR": "Cor do veículo",
    "CAR_ARRIVED.REMEMBER": "Lembrar dos dados do meu veículo",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Exemplo: C-49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Exemplo: FFF-1010)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Exemplo: Jeep Renegate)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Exemplo: Preto)",
    "REDIRECT_PICKUP.TO": "Para",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Alterar o local de retirada?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Local de retirada alterado com sucesso.",
    "REDIRECT_PICKUP.FAILED_TITLE": "Não foi possível alterar o local de retirada",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Algo deu errado",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Selecione o local de retirada",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Definir como local de retirada",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Opções de retirada",
    "SOON": "Em breve",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Ligar para o entregador ?",
    "GLOBAL.CALL": "Ligar",
    "GLOBAL.CANCEL": "Cancelar",
    "﻿PICKUP.SET_PICKUP_TIME": "Estou a caminho",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Seu pedido está esperando por você em frente da sua porta!",
    "SCHEDULED.THANKS_FOR_USING": "Obrigado por utilizar {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Seu envio {{externo_id}} está em trânsito",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Sua entrega está programada para",
    "Submit": "Enviar",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Para avaliar, selecione primeiro as estrelas",
    "PICKUP.SHOW_ID": "Mostrar Senha",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Hora estimada de chegada",
    "OPEN_MENU": "Abrir menu",
    "CLOSE_MENU": "Fechar menu",
    "MAP_AUTO_CENTER": "Mapa do centro automotivo",
    "MAP_SETTINGS": "Configurações do mapa",
    "ZOOM_OUT": "Reduzir o zoom",
    "ZOOM_IN": "Aumentar o zoom",
    "TRACKING.CALL_DRIVER": "Ligar para o motorista",
    "TRACKING.MESSAGE_DRIVER": "Enviar uma mensagem para o driver",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Confirme o horário de chegada da coleta",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Não queremos que você espere.\nAvise-nos quando estiver a caminho ou chegando:",
    "SCHEDULE.TIME_ZONE_TEXT": "Fuso horário",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Estamos trabalhando nisso!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Estamos coletando seus itens e um membro da equipe chegará ao seu carro em breve",
    "TRACKING.THANKS_MESSAGE_TITLE": "Obrigado por fazer o check-in",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Por favor, dirija-se ao ponto de coleta na loja onde seu pedido está pronto para ser retirado",
    "CANCEL_ORDER": "Cancelar pedido",
    "CANCELLATION_VALIDATION_TITLE": "Tem certeza de que deseja cancelar este pedido?",
    "CANCELLATION_VALIDATION_BACK": "Voltar",
    "CANCELLATION_VALIDATION_YES": "Sim, por favor",
    "CANCEL_SUCCESS": "Cancelamos seu pedido",
    "CANCEL_PAST_ALLOWED": "O cancelamento do pedido expirou",
    "CANCEL_ERROR": "Não foi possível cancelar seu pedido",
    "RATING.FREE_TEXT_COMMENT": "Conte-nos mais",
    "RATING.ORDER_DELIVERED_GREEN": "Entregamos seu pedido com um veículo ecológico",
    "CX_ORDER_STATUS.CONFIRMED": "Pedido confirmado. Estamos trabalhando nisso.",
    "CX_ORDER_STATUS.RECEIVED": "Pedido Recebido. Entraremos em contato em breve.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Estamos procurando um motorista para entregar o seu pedido.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Encontramos o motorista para o seu pedido.",
    "CX_ORDER_STATUS.PICKING_UP": "Estamos coletando o seu pedido agora.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Estamos a caminho para coletar o seu pedido.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Estamos concluindo uma entrega antes do seu pedido.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "O seu pedido está a caminho de você agora!",
    "CX_ORDER_STATUS.ARRIVED": "O seu pedido chegou!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Status da entrega",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Mostrar status de entrega aos clientes",
    "CONFIRM": "Confirmar",
    "FLOW_OPTIONS.TITLE": "Como você quer retirar seu pedido?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Entregue no seu carro em um local designado",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Retirada no veículo",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Retire na loja ou em um local estabelecido",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Clique e retire",
    "RATING_STAR_ALT": "Selecione até 5 estrelas para enviar uma avaliação",
    "RATING_STAR_ALT_ONE": "Selecione para deixar a classificação de",
    "RATING_STAR_ALT_TWO": "estrelas",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "O tempo estimado de chegada é de",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Mapear para rastrear o pedido",
    "SCHEDULE.EXTERNAL_ID_INFO": "ID do Pedido: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Comentário",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Eliminar",
    "DELIVERY_WAS_CANCELLED": "Entrega cancelada",
    "QUESTIONNAIRE.SKIP": "Pular",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Tem certeza que deseja pular?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Algumas perguntas não foram respondidas. Tem certeza que deseja continuar sem completá-las?",
    "QUESTIONNAIRE.BACK": "Voltar",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "Precisa de outro horário?",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "Reagendar sua entrega",
    "RESCHEDULE.GREETING": "Olá 👋 Sou o assistente de reagendamento da {{merchant_name}}. Seu pedido #{{order_id}} está agendado para {{delivery_window}}.\n\nPrecisa mudar a janela de entrega? Selecione uma opção abaixo e a gente resolve.",
    "RESCHEDULE.FIRST_AVAILABLE": "Primeiro disponível",
    "RESCHEDULE.SAME_DAY": "Mesmo dia, outro horário",
    "RESCHEDULE.PICK_A_DATE": "Escolher uma data",
    "RESCHEDULE.NEAREST_WINDOWS": "Estas são as janelas disponíveis mais próximas. Selecione a data que funciona para você",
    "RESCHEDULE.WINDOWS_FOR_DATE": "Estas são todas as janelas disponíveis para {{date}}. Selecione a que funciona para você",
    "RESCHEDULE.WHICH_DATE": "Qual data funciona melhor para você?",
    "RESCHEDULE.NO_WINDOWS": "Desculpe, não há janelas disponíveis para esse dia. Tente outra data",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "Desculpe, no momento não há janelas disponíveis para reagendar.",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "Ocorreu um erro ao carregar as janelas disponíveis. Tente novamente.",
    "RESCHEDULE.TRY_AGAIN": "Tentar novamente",
    "RESCHEDULE.BACK_TO_START": "Voltar ao início",
    "RESCHEDULE.BACK_TO_DELIVERY": "Voltar para minha entrega",
    "RESCHEDULE.CONFIRMED": "Tudo certo! A entrega agora está agendada para {{delivery_window}}. Tenha um ótimo dia!",
    "RESCHEDULE.TYPE_A_MESSAGE": "Digite uma mensagem",
    "RESCHEDULE.TODAY": "Hoje"
};
	